import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, InfoTag, Typography, useBreakpoint, Button, getTestId, isValidObject } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getTextType } from '../../OrderSummaryCardWidgetStyles';
import { getPriceDetailsStyles } from './PriceDetailsStyles';
var PriceDetails = props => {
  var _a, _b, _c, _d, _e;
  var _props$priceDetails = props.priceDetails,
    priceDetails = _props$priceDetails === void 0 ? {} : _props$priceDetails,
    _props$infoTagText = props.infoTagText,
    infoTagText = _props$infoTagText === void 0 ? '' : _props$infoTagText,
    _props$infoTagProps = props.infoTagProps,
    infoTagProps = _props$infoTagProps === void 0 ? {} : _props$infoTagProps,
    _props$priceDetailsTe = props.priceDetailsTertiaryCtaProps,
    priceDetailsTertiaryCtaProps = _props$priceDetailsTe === void 0 ? {} : _props$priceDetailsTe,
    onViewDetailsInPriceSegmentPressMetaData = props.onViewDetailsInPriceSegmentPressMetaData,
    _props$strikePriceAcc = props.strikePriceAccessibilityProps,
    strikePriceAccessibilityProps = _props$strikePriceAcc === void 0 ? {} : _props$strikePriceAcc,
    onUserAction = props.onUserAction,
    id = props.id,
    index = props.index,
    testID = props.testID;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var priceDetailsStyles = getPriceDetailsStyles(props);
  var infoTagSize = isSmallScreen ? 'sm' : 'md';
  return _jsxs(View, Object.assign({
    style: priceDetailsStyles.prideDetailsContainer
  }, getTestId(testID, 'priceDetails'), {
    children: [_jsxs(View, Object.assign({
      style: priceDetailsStyles.priceDetailsTextContainer
    }, {
      children: [!!priceDetails && Object.keys(priceDetails).length > 0 && ((_a = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.price) === null || _a === void 0 ? void 0 : _a.length) > 0 && _jsx(Typography, Object.assign({
        type: (_b = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.priceType) !== null && _b !== void 0 ? _b : getTextType('heading', isSmallScreen),
        text: priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.price,
        color: (_c = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.priceColor) !== null && _c !== void 0 ? _c : BLACK_900,
        style: priceDetailsStyles.priceTexts
      }, getTestId(testID, 'priceDetailsPrice'))), !!priceDetails && Object.keys(priceDetails).length > 0 && ((_d = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.oldPrice) === null || _d === void 0 ? void 0 : _d.length) > 0 && _jsx(Typography, Object.assign({
        type: getTextType('subheading', isSmallScreen),
        text: priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.oldPrice,
        color: (_e = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.color) !== null && _e !== void 0 ? _e : BLACK_700,
        style: [priceDetailsStyles.priceTexts, priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.style],
        isStriked: priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.isOldPriceStriked
      }, getTestId(testID, 'priceDetailsOldPrice'), (priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.isOldPriceStriked) ? strikePriceAccessibilityProps : {}))]
    })), (infoTagText === null || infoTagText === void 0 ? void 0 : infoTagText.length) > 0 && _jsx(InfoTag, Object.assign({
      text: infoTagText,
      type: "inline",
      size: infoTagSize,
      style: priceDetailsStyles.infoTag
    }, infoTagProps, getTestId(testID, 'infoTagText'))), isValidObject(priceDetailsTertiaryCtaProps) && _jsx(Button, Object.assign({
      buttonType: "tertiary",
      size: "sm",
      style: priceDetailsStyles.tertiaryActionButton
    }, priceDetailsTertiaryCtaProps, {
      onPress: () => {
        onViewDetailsInPriceSegmentPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onViewDetailsInPriceSegmentPressMetaData), {
          index,
          item: props
        }));
      }
    }, getTestId(testID, 'tertiaryActionButtonText')))]
  }));
};
export default PriceDetails;